import React, { Component } from "react";
import {
  SingleDropdownList,
  MultiList
} from "@appbaseio/reactivesearch";

const item_order = [
"D",
"E" ,
"F",
"G",
"H",
"I",
"J",
"K"
]

const item_order2 = [
"D",
"DE",
"D-E",
"E",
"F",
"EF",
"E-G",
"FG",
"G",
"GH",
"F-H",
"H",
"HI",
"G-I",
"F-I",
"I",
"IJ",
"J",
"JK",
"I-K",
"K"
]

class DiamondColorRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startValue: '',
      endValue: ''
    };
    this.handleStartChange = this.handleStartChange.bind(this);
    this.handleEndChange = this.handleEndChange.bind(this);
    this.mapOrder = this.mapOrder.bind(this);
    this.sortedArr = this.sortedArr.bind(this);
  }
  handleStartChange(value) {
    this.setState({
      startValue: value
    });
  }
  handleEndChange(value) {
    this.setState({
      endValue: value
    });
  }
  mapOrder(array, order, key) {
    array.sort(function(a, b) {
      var A = a[key],
        B = b[key];
      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }
    });
    return array;
  }
  sortedArr(array, order) {
    let arr = []
    for (let i = 0; i < order.length; i++) {
      for (let j = 0; j < array.length; j++) {
        if (order[i] === array[j].key) {
          arr.push(array[j])
        }
      }
    }
    return arr
  }

  render() {
    let { startValue, endValue } = this.state;
    let value;
    if (!startValue && !endValue) {
      value = null;
    } else if (startValue && !endValue) {
      value = item_order2.slice(item_order2.indexOf(startValue));
    } else if(!startValue && endValue) {
      value = item_order2.slice(0, item_order2.indexOf(endValue) + 1);
    } else {
      if( item_order2.indexOf(startValue)>item_order2.indexOf(endValue)){
        value = item_order2.slice(
          item_order2.indexOf(endValue),
          item_order2.indexOf(startValue) + 1
        );
      }else{
        value = item_order2.slice(
          item_order2.indexOf(startValue),
          item_order2.indexOf(endValue) + 1
        );
      }
     
    }
    return (
      <div className="diamond-range form-field-wrap">
        <div className="color-input-dropdowns">
          <h2>Dia Color</h2>
          <SingleDropdownList
            componentId="DiamondStartColor"
            className="start-range large-dropdown"
            dataField="StudsColor.keyword"
            size={100}
            placeholder=""
            sortBy="count"
            showCount={false}
            showFilter={true}
            filterLabel="DiaStartColor"
            onValueChange={value => this.handleStartChange(value)}
            transformData={list => {
              const ordered_array = this.sortedArr(list, item_order);
              return ordered_array
            }}
          />
          <span>-</span>
          <SingleDropdownList
            componentId="DiamondEndColor"
            className="end-range large-dropdown"
            dataField="StudsColor.keyword"
            size={100}
            placeholder=""
            sortBy="count"
            showCount={false}
            showFilter={true}
            filterLabel="DiaEndColor"
            onValueChange={value => this.handleEndChange(value)}
            transformData={list => {
              const ordered_array = this.sortedArr(list, item_order);
              return ordered_array
            }}
          />
          <MultiList
            componentId="DiamondColorRange"
            className="hide__multilist"
            dataField="StudsColor.keyword"
            title="Color"
            value={value}
            size={100}
            sortBy="asc"
            queryFormat="or"
            showSearch={false}
            showFilter={false}
            react={{
              or: ["DiamondStartColor", "DiamondEndColor"]
            }}
          />
        </div>
      </div>
    );
  }
}

export default DiamondColorRange;
